import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusCiTypeComponent } from './status-ci-type.component';

@NgModule({
	declarations: [],
	imports: [CommonModule, StatusCiTypeComponent],
	exports: [StatusCiTypeComponent],
})
export class StatusCiTypeModule {}
